export default __webpack_public_path__ + "static/media/bootstrap.50b9c74b.png";